import type { IconSvgObject } from './types';

const DiamondMinusIcon: IconSvgObject = [
  ["path", { d: "M13.7071 2.70711L21.2929 10.2929C21.7456 10.7456 22 11.3597 22 12C22 12.6403 21.7456 13.2544 21.2929 13.7071L13.7071 21.2929C13.2544 21.7456 12.6403 22 12 22C11.3597 22 10.7456 21.7456 10.2929 21.2929L2.70711 13.7071C2.25435 13.2544 2 12.6403 2 12C2 11.3597 2.25435 10.7456 2.70711 10.2929L10.2929 2.70711C10.7456 2.25435 11.3597 2 12 2C12.6403 2 13.2544 2.25435 13.7071 2.70711Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 12H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default DiamondMinusIcon;
